<template>
  <div class="home-view">
    <!-- Hero -->
    <div class="hero" :style="heroStyle">
      <div class="hero-content">
        <h1>{{ config.content.heroTitle }}</h1>
        <router-link to="/transfer" class="btn ube-l-btn mx-3">
          {{ config.content.heroCTAText }}
        </router-link>
        <router-link
          v-if="twoToFourYearEnabled"
          to="/TwoYeartoFourYear"
          class="btn ube-l-btn-secondary mx-3"
        >
          2 Year to 4 Year Plan
        </router-link>
      </div>
    </div>

    <!-- Section -->
    <div class="container-fluid">
      <div class="row information">
        <h2>How it works</h2>
        <div class="col-md-4">
          <img class="icon" src="../assets/university.png" alt="university" />
          <p>Select your community college</p>
        </div>
        <div class="col-md-4">
          <img class="icon" src="../assets/graduation.png" alt="graduation" />
          <p>
            Select courses completed or in progress at your community college
          </p>
        </div>
        <div class="col-md-4">
          <img class="icon" src="../assets/program.png" alt="program" />
          <p>Select the intended program/major at {{ config.branding.name }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed } from "vue";
import { useTenantConfig } from "@/composables/useTenantConfig";
import { useFeatureFlags } from "@/composables/useFeatureFlags";

export default defineComponent({
  name: "HomeView",
  setup() {
    const { config } = useTenantConfig();
    const { twoToFourYearEnabled } = useFeatureFlags();

    // Compute hero background image URL
    const heroImageUrl = computed(() => {
      return new URL(`../assets/${config.branding.heroImage}`, import.meta.url).href;
    });

    // Compute hero style with background image
    const heroStyle = computed(() => ({
      backgroundImage: `url(${heroImageUrl.value})`,
    }));

    return {
      config,
      twoToFourYearEnabled,
      heroStyle,
    };
  },
});
</script>
